//预付费
export default [{
	//预付费表管理
	path: '/tableManagement',
	name: 'tableManagement',
	component: () => import('@/page/system/prepaid/tableManagement.vue')
}]